import React from "react";

/* ============================================================================
 * SupervisorDashboard — placeholder, same shell as IgluDashboard.
 *   Renders inline in a tab (no onClose) or as a modal (with onClose).
 * ==========================================================================*/

const S = {
  backdrop: { position:"fixed", inset:0, top: "var(--fr-modal-top, 0px)", background:"rgba(2,6,23,0.7)", zIndex:1100,
    display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"40px 16px", overflowY:"auto" },
  modal: { position:"relative", maxHeight: "calc(var(--fr-modal-max, 82vh) - 76px)", overflowY: "auto", overscrollBehavior: "contain", width:"100%", maxWidth:1200,
    background:"linear-gradient(135deg,#1e293b 0%,#0f172a 100%)",
    border:"1px solid rgba(34,211,238,0.25)", borderRadius:16, padding:"18px 18px 14px" },
  accent: { position:"absolute", top:0, left:0, right:0, height:3,
    background:"linear-gradient(90deg,#22d3ee,#3b82f6,#8b5cf6)" },
  head: { position: "sticky", top: 0, zIndex: 5, background: "#1e293b", boxShadow: "0 -18px 0 0 #1e293b",  display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12 },
  title: { margin:0, fontSize:"1rem", fontWeight:700, color:"#f1f5f9" },
  closeX: { background:"none", border:"none", color:"rgba(255,255,255,0.6)", fontSize:"1.4rem", lineHeight:1, cursor:"pointer" },
  card: { background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.08)",
    borderRadius:12, padding:"48px 24px", marginTop:8, textAlign:"center" },
  soon: { fontSize:"1.05rem", fontWeight:700, color:"#22d3ee", letterSpacing:"0.04em", margin:0 },
  sub: { fontSize:"0.8rem", color:"rgba(255,255,255,0.45)", fontStyle:"italic", marginTop:8 },
  closeBtn: { width:"100%", padding:"11px", borderRadius:10, border:"none",
    background:"rgba(255,255,255,0.06)", color:"#e2e8f0", fontWeight:600, cursor:"pointer", marginTop:12 },
};

const SupervisorDashboard = ({ onClose }) => {
  const inline = !onClose;                    // rendered inside a tab, not as a modal

  const shell = (
    <div style={{ ...S.modal, margin: inline ? "0 auto" : undefined }}
      onClick={(e) => e.stopPropagation()}>
      <div style={S.accent} />
      <div style={S.head}>
        <h4 style={S.title}>Supervisor Dashboard</h4>
        {!inline && (
          <button type="button" style={S.closeX} onClick={onClose} aria-label="Close">×</button>
        )}
      </div>

      <div style={S.card}>
        <p style={S.soon}>Coming soon…</p>
        <p style={S.sub}>Supervisor tools are on the way.</p>
      </div>

      {!inline && (
        <button type="button" style={S.closeBtn} onClick={onClose}>Close</button>
      )}
    </div>
  );

  return inline ? shell : (
    <div style={S.backdrop} onClick={onClose}>{shell}</div>
  );
};

export default SupervisorDashboard;